import { NavLink } from "react-router-dom";
import { LifeBuoy } from "lucide-react";
import { useSupportNotifications } from "@/lib/SupportNotificationsContext";

export const SupportNavLink = ({ admin = false }) => {
  const { unread } = useSupportNotifications();
  const id = admin ? "admin-support" : "support";
  return (
    <NavLink to={admin ? "/admin/assistenza" : "/assistenza"}
             className={admin
               ? ({ isActive }) => `block px-3 md:px-6 py-2.5 md:py-3 text-xs md:text-sm hover:bg-white/[0.04] ${isActive ? "border-l-2 border-[#C5B39B] bg-white/[0.03]" : ""}`
               : ({ isActive }) => isActive ? "active" : ""}
             data-testid={`${id}-nav-link`}>
      <LifeBuoy className="inline w-4 h-4 mr-3" strokeWidth={1.5} />Assistenza
      {unread > 0 && <span className="ml-2 text-xs bg-[#C5B39B] text-[#1A1A1A] px-1.5 py-0.5 rounded-sm"
                            data-testid={`${id}-unread-count`}>{unread > 99 ? "99+" : unread}</span>}
    </NavLink>
  );
};